import {
  CLEAR_EAI_DATA_SUCCESS,
  CREATE_EMPLOYEE_ASSET_ISSUE_SUCCESS,
  FETCH_EMPLOYEE_ASSET_ISSUE_SUCCESS,
  FETCH_EMPLOYEE_ASSETS_BY_LOCATION_SUCCESS,
  GET_EMPLOYEE_ASSET_ISSUE_SUCCESS,
  SAVE_EMPLOYEE_ASSET_ISSUE_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  assetsList: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_EMPLOYEE_ASSET_ISSUE_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_EMPLOYEE_ASSET_ISSUE_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_EMPLOYEE_ASSET_ISSUE_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_EMPLOYEE_ASSET_ISSUE_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    case FETCH_EMPLOYEE_ASSETS_BY_LOCATION_SUCCESS: {
      return {
        ...state,
        assetsList: action.data,
      }
    }
    case CLEAR_EAI_DATA_SUCCESS: {
      return {
        ...state,
        assetsList: [],
        edit:{}
      }
    }


    default:
      return state;
  }
}
